export default function SetFocusOnDirective($timeout, $parse) {
  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var model = $parse(attrs.setFocusOn);
      scope.$watch(model, function(currentValue) {
        if (currentValue === true) {
          $timeout(function() {
            element[0].focus();
          });
        }
      });
      element.bind('blur', function() {
        if (model.assign) {
          // use timeout to avoid [$rootScope:inprog] error
          $timeout(() => scope.$apply(model.assign(scope, false)), 0, false);
        }
      });
    },
  };
}
